import styled from "styled-components";
import Grid from "../../../../../components/Grid";
import PrimaryButton from "../../../../../components/FormControls/PrimaryButton";
import { useNavigate } from "react-router-dom";
import { useEffect } from "react";

const StyledBranchSettingsLeftPane = styled.div`
	background-color: white;
	width: 369px;
	min-height: 573px;
    box-sizing: border-box;
	height: 100%;
	padding: 30px;
`;

function BranchSettingsLeftPane(props) {

    const navigate = useNavigate();

	const {gridColumns, gridData, gridStyle, branchIdToSelect, onSelectGridItem, isAddMode, setIsAddMode} = props;

	const handleClickCreateNewBranch = () => {
		if (setIsAddMode) {
			setIsAddMode(true);
			navigate('/settings/branch/main');
		}
	}

    return (
        <StyledBranchSettingsLeftPane>
			<Grid id='branchsetting_leftpane_grid' gridColumns={gridColumns} gridData={gridData} disabled={isAddMode} itemIdToSelect={branchIdToSelect} onSelectGridItem={onSelectGridItem} gridStyle={gridStyle}></Grid>
			{!isAddMode && <PrimaryButton caption='Create new' onClick={() => handleClickCreateNewBranch()} style={{width:100, marginTop:28, float:'right'}}></PrimaryButton>}
		</StyledBranchSettingsLeftPane>
    )
}

export default BranchSettingsLeftPane;